import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

import moment from 'moment'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { es } from 'date-fns/locale'

// estilos
import '../../assets/style/componentPrincipal.css'
import '../../assets/style/tablesG.css'

// componentes
// import { Buscar } from '../general/buscadorCobros/Buscar';
import { ModalProgress } from '../modals/ModalProgress';
// import { TableList } from './TableList';

import { Model } from '../../models/model';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';

export const FlowList = () => {

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])

    const [filters, setFilters] = useState({
        time: 'all',
        text: '',
        id_contacto: '',
        tipo_flujo: '',
        id_ppto: '',
        estado: 'pendiente',
        fecha_desde: new Date(),
        fecha_hasta: new Date(),
        check_emitida: true,
        check_pagada: true,
        view: 'flujos',
        page: 1,
        rows: 10
    })

    const handleGetAll = useCallback(async () => {
        const results = await Model.getAll({
            url: `flows/?${(new URLSearchParams(filters)).toString()}`
        })

        console.log('flows---', { results })

        setData(results)
    }, [filters])

    const handleChangeDateDesde = (newValue) => {
        setFilters({
            ...filters,
            fecha_desde: newValue
        })
    }

    const handleChangeDateHasta = (newValue) => {
        setFilters({
            ...filters,
            fecha_hasta: newValue
        })
    }

    useEffect(() => {
        setLoading(true)
        handleGetAll(filters)
        setLoading(false)
    }, [filters, handleGetAll])

    return (
        <div className='p-container'>
            {loading && <ModalProgress />}

            <h1 className='p-title'>Flujos proyectados</h1>

            <DateFilters
                filters={filters}
                setFilters={setFilters}
                handleChangeDateDesde={handleChangeDateDesde}
                handleChangeDateHasta={handleChangeDateHasta}
            />

            <FlujosGlobales
                data={data}
                filters={filters}
                setFilters={setFilters}
            />

            {/* <FlujosGlobalesV2
                data={data}
            /> */}

            {/* <TableList
                filters={filters}
                setFilters={setFilters}
                dataList={cobrosList}
            /> */}

        </div >
    )
}

const DateFilters = ({ filters, setFilters, handleChangeDateDesde, handleChangeDateHasta }) => {
    return (
        <>
            <div className="row mt-3">
                <div className="col text-start">
                    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio4" autoComplete="off"
                            checked={filters.time === 'all' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'all' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio4" style={{ color: filters.time === 'all' ? '#8E24AA' : '#595759' }}>
                            Todos los pendientes
                        </label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off"
                            checked={filters.time === 'year' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'year' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio1" style={{ color: filters.time === 'year' ? '#8E24AA' : '#595759' }}>
                            Anual ({moment(filters.fecha_desde).format('YYYY')})
                        </label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off"
                            checked={filters.time === 'month' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'month' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio2" style={{ color: filters.time === 'month' ? '#8E24AA' : '#595759' }}>
                            Mensual (<span style={{ textTransform: 'capitalize' }}>{moment(filters.fecha_desde).format('MMMM')}</span>{' '}{moment(filters.fecha_desde).format('YYYY')})
                        </label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off"
                            checked={filters.time === 'range' && 'checked'}
                            onChange={() => setFilters({ ...filters, time: 'range' })}
                        />
                        <label className="btn btn-outline-light" htmlFor="btnradio3" style={{ color: filters.time === 'range' ? '#8E24AA' : '#595759' }}>
                            Rango
                        </label>
                    </div>
                </div>
            </div>

            {filters.time === 'year' &&
                <div className='mt-4 p-text-date-year ms-2'>
                    <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={['year']}
                            label="Año"
                            openTo="year"
                            name='fecha_desde'
                            minDate={new Date('2020-01-01')}
                            value={filters.fecha_desde}
                            onChange={handleChangeDateDesde}
                            renderInput={(params) => <TextField {...params} helperText={null} />}
                        />
                    </LocalizationProvider>
                </div>
            }

            {filters.time === 'month' &&
                <div className='mt-4 p-text-date-month'>
                    <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={['year', 'month']}
                            label="Mes"
                            openTo="month"
                            name='fecha_desde'
                            minDate={new Date('2020-01-01')}
                            value={filters.fecha_desde}
                            onChange={handleChangeDateDesde}
                            renderInput={(params) => <TextField {...params} helperText={null} />}
                        />
                    </LocalizationProvider>
                </div>
            }

            {filters.time === 'range' &&
                <div className="row mt-4">
                    <div className="col text-start d-flex justify-content-start p-text-date-range">
                        <span>
                            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={['year', 'month']}
                                    label="Mes desde"
                                    openTo="month"
                                    name='fecha_desde'
                                    minDate={new Date('2020-01-01')}
                                    value={filters.fecha_desde}
                                    onChange={handleChangeDateDesde}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={['year', 'month']}
                                    label="Mes hasta"
                                    openTo="month"
                                    name='fecha_hasta'
                                    minDate={new Date('2020-01-01')}
                                    value={filters.fecha_hasta}
                                    onChange={handleChangeDateHasta}
                                    renderInput={(params) => <TextField {...params} helperText={null} />}
                                />
                            </LocalizationProvider>
                        </span>
                    </div>
                </div>
            }

        </>
    )

}

const FlujosGlobales = ({ data, filters, setFilters }) => {

    const {
        // local_moneda: moneda,
        local_simbolo: simbolo,
        local_separacion_miles: separacion_miles,
        local_separacion_decimales: separacion_decimales
    } = useSelector(state => state.general.info)

    return (
        <div className="p-2 space-y-6 mt-3">

            {/* KPIs */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div className="bg-white rounded-2xl shadow p-4">
                    <h3 className="text-sm text-gray-500">Ingresos proyectados</h3>
                    <Link
                        to=""
                        onClick={() => setFilters({ ...filters, view: 'flujos' })}
                    >
                        <p className="text-xl font-semibold text-green-600 text-start">
                            <NumberFormat
                                value={data?.total_ingresos || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                        </p>
                    </Link>
                </div>
                <div className="bg-white rounded-2xl shadow p-4">
                    <h3 className="text-sm text-gray-500">Egresos proyectados</h3>
                    <Link
                        to=""
                        onClick={() => setFilters({ ...filters, view: 'flujos' })}
                    >
                        <p className="text-xl font-semibold text-red-600 text-start">
                            <NumberFormat
                                value={data?.total_egresos || 0}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                        </p>
                    </Link>
                </div>
                <div className="bg-white rounded-2xl shadow p-4">
                    <h3 className="text-sm text-gray-500">Saldo neto</h3>
                    <p className="text-xl font-semibold text-blue-600">
                        <NumberFormat
                            value={data?.total_saldo || 0}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </p>
                </div>

                {/* <div className="bg-white rounded-2xl shadow p-4">
                    <h3 className="text-sm text-gray-500">% proyectos en riesgo</h3>
                    <p className="text-xl font-semibold text-orange-500">25%</p>
                </div> */}

                <div className="bg-white rounded-2xl shadow p-4">
                    {/* <h3 className="text-sm text-gray-500">Flujos en riesgo</h3> */}
                    <h3 className="text-sm text-gray-500">Proyectos en riesgo</h3>
                    <Link
                        to=""
                        onClick={() => setFilters({ ...filters, view: 'proyectos' })}
                    >
                        <p className="text-xl font-semibold text-orange-500 text-start">{data?.cant_riesgo || 0} proyectos</p>
                    </Link>
                </div>

            </div>

            {/* Gráfico (placeholder) */}
            {/* <div className="bg-white rounded-2xl shadow p-6">
                <h2 className="text-lg font-semibold mb-4">Flujos proyectados por mes</h2>
                <div className="h-64 flex items-center justify-center text-gray-400 border border-dashed rounded-lg">
                    Gráfico ingresos (verde) vs egresos (rojo) vs saldo (azul)
                </div>
            </div> */}

            {/* Tabla de proyectos */}

            <div>

                <select
                    className='border p-1 m-2 rounded'
                    onChange={(e) => setFilters({ ...filters, view: e.target.value })}
                >
                    <option value="flujos">Vista por flujos</option>
                    <option value="proyectos">Vista por proyectos</option>
                </select>

                {filters.view === 'flujos' ?
                    <ListaPorFlujos
                        flows={data?.flows || []}
                    />
                    :
                    <ListaPorProyectos
                        projects={data?.projects || []}
                    />
                }
            </div>

        </div>
    )
}

const ListaPorFlujos = ({ flows }) => {
    return (
        <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-lg font-semibold mb-4">Flujos pendientes</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                    <thead>
                        <tr className="bg-gray-50 text-left">
                            <th className="p-2">Proyecto</th>
                            <th className="p-2">Ítem</th>
                            <th className="p-2">Contacto</th>
                            <th className="p-2">Fecha</th>
                            <th className="p-2">Tipo</th>
                            <th className="p-2 text-end pe-5">Total</th>
                            <th className="p-2">Estado</th>
                            <th className="p-2">Documento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {flows.map(it => (
                            <tr className="border-t" key={it.id}>
                                <td className="p-2 uppercase text-[12px] text-black">
                                    <Link
                                        className='hover:underline text-black'
                                        to={`/projects/${it?.id_ppto}`}
                                        target='_blank'
                                    >
                                        {it.nombre_proyecto}
                                    </Link>
                                </td>
                                <td className="p-2 lowercase first-letter:uppercase">{it?.nombre_item || '--'}</td>
                                <td className="p-2 lowercase first-letter:uppercase">{it?.nombre_contacto || '--'}</td>
                                <td className="p-2">{moment(it.fecha_proyeccion).format('DD-MM-YYYY')}</td>
                                <td className={`p-2 capitalize ${it.tipo_flujo === 'ingreso' ? ' text-green-600' : 'text-red-600'}`}>{it.tipo_flujo}</td>
                                <td className="p-2 text-green-600 text-end">
                                    {it.tipo_flujo === 'ingreso' ?
                                        <NumberFormat
                                            className="text-green-600 me-3"
                                            value={parseFloat(it?.monto_neto) || 0}
                                            displayType={'text'}
                                            thousandSeparator={it.separacion_miles}
                                            decimalSeparator={it.separacion_decimales}
                                            prefix={`${it.simbolo} `}
                                            decimalScale={2}
                                            fixedDecimalScale={2}
                                        />
                                        :
                                        <NumberFormat
                                            className="text-red-600 me-3"
                                            value={parseFloat(it?.total) || 0}
                                            displayType={'text'}
                                            thousandSeparator={it.separacion_miles}
                                            decimalSeparator={it.separacion_decimales}
                                            prefix={`${it.simbolo} `}
                                            decimalScale={2}
                                            fixedDecimalScale={2}
                                        />
                                    }
                                </td>
                                <td className="p-2">
                                    <span className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-600">
                                        {it.estado}
                                    </span>
                                </td>
                                <td className="p-2">
                                    <span className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-600 m-1">
                                        {it?.info_doc ?
                                            <label>Nro. {it?.info_doc?.numero}</label>
                                            :
                                            '---'
                                        }
                                    </span>
                                    {it?.info_doc ?
                                        <span className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-600 m-1">{it?.info_doc?.estado}</span>
                                        : ''
                                    }
                                </td>
                            </tr>
                        ))}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

const ListaPorProyectos = ({ projects }) => {
    return (
        <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-lg font-semibold mb-4">Proyectos en proceso</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                    <thead>
                        <tr className="bg-gray-50 text-left">
                            <th className="p-2">Proyecto</th>
                            <th className="p-2">Ingresos</th>
                            <th className="p-2">Egresos</th>
                            <th className="p-2">Saldo</th>
                            <th className="p-2">Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {projects.map(it => (
                            <tr className="border-t" key={it.id}>
                                <td className="p-2 uppercase text-[12px] text-black">
                                    <Link
                                        className='hover:underline text-black'
                                        to={`/projects/${it?.id}`}
                                        target='_blank'
                                    >
                                        {it.nombre}
                                    </Link>
                                </td>
                                <td className="p-2 text-green-600">
                                    <NumberFormat
                                        value={parseFloat(it?.total_ingresos) || 0}
                                        displayType={'text'}
                                        thousandSeparator={it.separacion_miles}
                                        decimalSeparator={it.separacion_decimales}
                                        prefix={`${it.simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale={2}
                                    />
                                </td>
                                <td className="p-2 text-red-600">
                                    <NumberFormat
                                        value={parseFloat(it?.total_egresos) || 0}
                                        displayType={'text'}
                                        thousandSeparator={it.separacion_miles}
                                        decimalSeparator={it.separacion_decimales}
                                        prefix={`${it.simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale={2}
                                    />
                                </td>
                                <td className="p-2 text-blue-600">
                                    <NumberFormat
                                        value={parseFloat(it?.saldo) || 0}
                                        displayType={'text'}
                                        thousandSeparator={it.separacion_miles}
                                        decimalSeparator={it.separacion_decimales}
                                        prefix={`${it.simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale={2}
                                    />
                                </td>
                                <td className="p-2">
                                    {it?.en_riesgo ?
                                        <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-600">
                                            En riesgo
                                        </span>
                                        :
                                        <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-600">
                                            Saludable
                                        </span>
                                    }
                                </td>
                            </tr>
                        ))}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

// const FlujosGlobalesV2 = () => {
//     return (
//         <div className="p-6 space-y-6">
//             {/* KPIs */}
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                 <div className="bg-white rounded-2xl shadow p-4">
//                     <h3 className="text-sm text-gray-500">Ingresos cobrados</h3>
//                     <p className="text-xl font-semibold text-green-600">$150,000</p>
//                 </div>
//                 <div className="bg-white rounded-2xl shadow p-4">
//                     <h3 className="text-sm text-gray-500">Egresos pagados</h3>
//                     <p className="text-xl font-semibold text-red-600">$90,000</p>
//                 </div>
//                 <div className="bg-white rounded-2xl shadow p-4">
//                     <h3 className="text-sm text-gray-500">Proyección neta</h3>
//                     <p className="text-xl font-semibold text-blue-600">$70,000</p>
//                 </div>
//                 <div className="bg-white rounded-2xl shadow p-4">
//                     <h3 className="text-sm text-gray-500">Flujos en riesgo</h3>
//                     <p className="text-xl font-semibold text-orange-500">2 proyectos</p>
//                 </div>
//             </div>

//             {/* Gráfico (placeholder) */}
//             <div className="bg-white rounded-2xl shadow p-6">
//                 <h2 className="text-lg font-semibold mb-4">Flujos proyectados por mes</h2>
//                 <div className="h-64 flex items-center justify-center text-gray-400 border border-dashed rounded-lg">
//                     {/* Aquí va el gráfico con Recharts o Chart.js */}
//                     <div className="text-center">
//                         <p className="mb-2">Ejemplo de visual:</p>
//                         <ul className="text-sm text-left">
//                             <li><span className="text-green-600 font-semibold">Verde sólido</span> = ingresos pagados</li>
//                             <li><span className="text-green-400 font-semibold">Verde claro</span> = ingresos proyectados</li>
//                             <li><span className="text-red-600 font-semibold">Rojo sólido</span> = egresos pagados</li>
//                             <li><span className="text-red-400 font-semibold">Rojo claro</span> = egresos proyectados</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>

//             {/* Tabla de proyectos */}
//             <div className="bg-white rounded-2xl shadow p-6">
//                 <h2 className="text-lg font-semibold mb-4">Proyectos activos</h2>
//                 <div className="overflow-x-auto">
//                     <table className="min-w-full text-sm">
//                         <thead>
//                             <tr className="bg-gray-50 text-left">
//                                 <th className="p-2">Proyecto</th>
//                                 <th className="p-2">Ingresos cobrados</th>
//                                 <th className="p-2">Ingresos proyectados</th>
//                                 <th className="p-2">Egresos pagados</th>
//                                 <th className="p-2">Egresos proyectados</th>
//                                 <th className="p-2">Saldo neto</th>
//                                 <th className="p-2">Estado</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             <tr className="border-t">
//                                 <td className="p-2">Cieneguilla 2E-91011</td>
//                                 <td className="p-2 text-green-600">$80,000</td>
//                                 <td className="p-2 text-green-400">$40,000</td>
//                                 <td className="p-2 text-red-600">$50,000</td>
//                                 <td className="p-2 text-red-400">$40,000</td>
//                                 <td className="p-2 text-blue-600">$30,000</td>
//                                 <td className="p-2">
//                                     <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-600">
//                                         Saludable
//                                     </span>
//                                 </td>
//                             </tr>
//                             <tr className="border-t">
//                                 <td className="p-2">Edificio Miraflores</td>
//                                 <td className="p-2 text-green-600">$20,000</td>
//                                 <td className="p-2 text-green-400">$60,000</td>
//                                 <td className="p-2 text-red-600">$40,000</td>
//                                 <td className="p-2 text-red-400">$55,000</td>
//                                 <td className="p-2 text-blue-600">-$15,000</td>
//                                 <td className="p-2">
//                                     <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-600">
//                                         En riesgo
//                                     </span>
//                                 </td>
//                             </tr>
//                             {/* más proyectos */}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     )
// }

